<div class="visible" *ngIf="errorDiv">
  <div class="row">
    <div class="alert-red col">
      {{errorMsg ? errorMsg : "Unable to handle the request. Please try again later."}}&nbsp;
    </div>
    <div class="col-3 align-right" *ngIf="enableMoreInfo">
      <a (click)="troubleshoot()" class="reference" >More Info</a>
    </div>
  </div>
  <div class="row" *ngIf="enableMoreInfo">
    <div class="col">
      <small>If you believe your credentials are correct, click on the <strong>More Info</strong> link on the right side for detailed diagnostic and guidance.</small>
    </div>
  </div>
</div>
